<script>
  import { fade } from 'svelte/transition';
  import { useLocation, Route } from "svelte-navigator";
  import { _ } from 'svelte-i18n'
  import { siteId } from '/i18n'
  import { sineIn } from 'svelte/easing';

  import { onAlmanac } from '/routes'
  import { styleVars } from '/helper'
  import { footerHeight, almanacOverlayActive } from '/stores'

  import Query from '/components/Atoms/Query'
  import TemplateAlmanac from '/components/Templates/TemplateAlmanac.svelte'
  import TemplateAlmanacItem from '/components/Templates/TemplateAlmanacItem.svelte'
  import TemplateHome from '/components/Templates/TemplateHome.svelte'
  import TemplateProgramme from '/components/Templates/TemplateProgramme.svelte'
  import TemplateNews from '/components/Templates/TemplateNews'
  import TemplateNewsItem from '/components/Templates/TemplateNewsItem'
  import TemplateSingle from '/components/Templates/TemplateSingle'
  import TemplateSupporters from '/components/Templates/TemplateSupporters'
  import TemplateArtists from '/components/Templates/TemplateArtists'
  import TemplateArtist from '/components/Templates/TemplateArtist'
  import TemplateArtwork from '/components/Templates/TemplateArtwork'
  import TemplateEvent from '/components/Templates/TemplateEvent'
  import TemplateVenue from '/components/Templates/TemplateVenue'
  import TemplateProject from '/components/Templates/TemplateProject'
  import TemplateLivestream from '/components/Templates/TemplateLivestream' 
  import TemplateAlamanacItemPreconditions from '/Groups/ArtworkPreconditions/TemplateAlamanacItemPreconditions'
  import Footer from '/Groups/Footer'
  import Delayed from '/Atoms/Delayed'

  import HOME_PAGE from '/gql/HomePage.gql'
  import NEWS from '/gql/News.gql'
  import TEXT from '/gql/Text.gql'
  import ALMANAC from '/gql/Almanac.gql'
  import PROGRAMME from '/gql/Programme.gql'
  import ARTISTS from '/gql/Artists.gql'
  import ARTIST from '/gql/Artist.gql'
  import ARTWORK from '/gql/Artwork.gql'
  import MEDIA from '/gql/Media.gql'
  import EVENT from '/gql/Event.gql'
  import VENUE from '/gql/Venue.gql'
  import PROJECT from '/gql/Project.gql'
  import STREAM_EVENTS from '/gql/streamEvents.gql'

  export let zIndex, hidden = false;

  const status = process.env.SHOW_PENDING ? ["live", "pending"] : ["live"]

  console.log("pending", process.env.SHOW_PENDING, status)

  const location = useLocation();
  //$: console.log($location)
  //$: console.log($footerHeight)
  //$: console.log($siteId)

  function slideup(node, { duration }) {
    return {
      duration,
      css: (t,u) => {
        const eased = sineIn(u);

        return `
          transform: translateY(${eased * 100}vh);
          `
      }
    };
  }

</script>

<main class:hidden style={ styleVars({zIndex, footerHeight:$footerHeight+"px"}) } class:almanac={ onAlmanac($location.pathname) } >
  <div class="frame">

    <Route path="/" >
      <Query gql={HOME_PAGE} variables={{ status, siteId: $siteId }} let:data>
        {#key data}
          <TemplateHome {data} />
        {/key}
      </Query>
    </Route>

    <Route path="/news/*" >
      <Route path="/">
        <Query gql={NEWS} variables={{ status, siteId: $siteId }} let:data >
          {#key data}
            <TemplateNews {data} />
          {/key}
        </Query>
      </Route>
      <Route path=":slug" let:params>
        <Query gql={TEXT} variables={{ slug: params.slug, status, siteId: $siteId }} let:data>
          {#key data}
            <TemplateNewsItem {data} />
          {/key}
        </Query>
      </Route>
    </Route>

    <Route path="/livestream" >
      <Query gql={PROJECT} variables={{ slug: "symposium", status, siteId: $siteId }} let:data >
        {#key data}
          <Query gql={STREAM_EVENTS} variables={{ status, id: ((data?.Project || {})?.relatedEvents || []).map(r => r.id)   }} let:data={data2}>
            <TemplateLivestream project={(data?.Project || {})} events={data2.related}/>
          </Query>
        {/key}
      </Query>
    </Route>

    <Route path="/artists">
      <Query gql={ARTISTS} variables={{ status, siteId: $siteId }} let:data >
        {#key data}
          <TemplateArtists title={$_('menu.artists')} {data} />
        {/key}
      </Query>
    </Route>

    <Route path="/people/:slug" let:params>
      <Query gql={ARTIST} variables={{ slug: params.slug, status, siteId: $siteId }} let:data >
        {#key data}
          <TemplateArtist {data} />
        {/key}
      </Query>
    </Route>

    <Route path="/artworks/:slug" let:params>
      <Query gql={ARTWORK} variables={{ slug: params.slug, status, siteId: $siteId }} let:data >
        <TemplateArtwork {data} />
      </Query>
    </Route>

    <Route path="/events/:slug" let:params>
      <Query gql={EVENT} variables={{ slug: params.slug, status, siteId: $siteId }} let:data >
        {#key data}
          <TemplateEvent {data} />
        {/key}
      </Query>
    </Route>

    <Route path="/venues/:slug" let:params>
      <Query gql={VENUE} variables={{ slug: params.slug, status, siteId: $siteId }} let:data >
        {#key data}
          <TemplateVenue {data} />
        {/key}
      </Query>
    </Route>

    {#key $location.pathname}
      <Route path="/projects/:slug" let:params>
        <Query gql={PROJECT} variables={{ slug: params.slug, status, siteId: $siteId }} let:data >
          {#key data}
            {#if data?.Project?.projectType.toLowerCase() === "partner"}
              <TemplateSingle {data} />
            {:else}
              <TemplateProject {data} />
            {/if}
          {/key}
        </Query>
      </Route>
    {/key}

    <Route path="/programme">
      <Query gql={PROGRAMME} variables={{ status, siteId: $siteId }} let:data>
        {#key data}
          <TemplateProgramme {data} />
        {/key}
      </Query>
    </Route>

    <Route path="/supporters">
      <Query gql={TEXT} variables={{ slug: "supporters", status, siteId: $siteId }} let:data>
        {#key data}
          <TemplateSupporters {data} />
        {/key}
      </Query>
    </Route>

      <Route path="/press-images">
        <Query gql={TEXT} variables={{ slug: "press-images", status, siteId: $siteId }} let:data>
          {#key data}
            <TemplateSupporters {data} />
          {/key}
        </Query>
      </Route>



      <Route path="/almanac/*slug" let:params primary={false}>

        <span style="display:none">
          {$location.pathname.indexOf("/almanac")}
        </span>

        <Delayed timeout={params.slug && params.slug !== "list" && params.slug !== "almanac-info" ? 2000 : 0}>
          <Query gql={ALMANAC} variables={{ status, siteId: $siteId }} let:data>
            {#key data}
              <TemplateAlmanac {data} listview={params.slug==="list"} infoview={params.slug==="almanac-info"}/>
            {/key}
          </Query>
        </Delayed>



        {#key $location.pathname}

          {#if params.slug && params.slug !== "list" && params.slug !== "almanac-info"}
            <Query gql={MEDIA} variables={{ slug: params.slug, status, siteId: $siteId }} let:data>
              <div class="almanac-overlay"
                  on:introend={    () => almanacOverlayActive.set(true )  }
                  on:outrostart={  () => almanacOverlayActive.set(false ) }
                  transition:fade="{{ duration: 400 }}"
                >
                  {#key data}
                    {#if params.slug === "noticing-the-preconditions-for_"}
                      <TemplateAlamanacItemPreconditions {data} />
                    {:else}
                      <TemplateAlmanacItem
                        {data}
                        bitnik={params.slug === "refuse-to-be-human"}
                        vampire={params.slug === "vampire-squid"}
                        liliana={params.slug === "gently-running-downwards"}
                      />
                    {/if}
                  {/key}
              </div>
            </Query>
          {/if}

        {/key}

      </Route>



    <!-- catch all single pages -->
    {#key $location.pathname}
      <Route path="*slug" let:params>
        {#if params.slug.indexOf("/") < 0}
          <Query gql={TEXT} variables={{ slug: params.slug, status, siteId: $siteId }} let:data >
            {#key data}
              <TemplateSingle {data} />
            {/key}
          </Query>
        {/if}
      </Route>
    {/key}


  </div>

  <Footer />

</main>

<style lang="scss">
  main {
    z-index: var(--zIndex);

    opacity: 1;
    &.hidden {
      opacity: 0;
    }
    transition: opacity 1s;

    .frame {
      box-sizing: border-box;
      padding-bottom: 20px;
      min-height: calc( 100vh - var(--footerHeight) );
      position: relative; z-index: 1; // make sure that the relative footer is not on top
      max-width: $maxwidth;
      margin: auto;
      padding-top: $frame-top-large;
      @include media-small {
        padding-top: $frame-top-small;
      }
    }
    &.almanac {
      background-color: $color-beige;
      min-height: 100vh;
      .frame {
        padding-top: 0;
        padding-bottom: 0;
      }
    }

    .almanac-overlay {
      position: fixed;
      top:0;
      left: 0;
      width: 100vw;
      height: 100vh;
      overflow: hidden;

    }
  }

</style>
